<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Acknowledgements"><span class="bold">Acknowledgements</span></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Introduction"><span class="bold">Introduction</span></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Author"><span class="bold">Author’s Notes</span></a></h2>
<h2 class="toca"><a href="#/xhtml/08_Chapter01">Chapter One</a></h2>
<h2 class="toca1"><a href="#/xhtml/08_Chapter01#ch1"><span class="bold">Origins of the Emergency</span></a></h2>
<h2 class="toca"><a href="#/xhtml/09_Chapter02">Chapter Two</a></h2>
<h2 class="toca1"><a href="#/xhtml/09_Chapter02#ch2"><span class="bold">Acclimatization and Evolution</span></a></h2>
<h2 class="toca"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toca1"><span href="#/xhtml/10_Chapter03#ch3" title="Link target outside of Sample"><span class="bold">The Upper Hand</span></span></h2>
<h2 class="toca"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toca1"><span href="#/xhtml/11_Chapter04#ch4" title="Link target outside of Sample"><span class="bold">‘The Best in Their Field’</span></span></h2>
<h2 class="toca"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Chapter Five</span></h2>
<h2 class="toca1"><span href="#/xhtml/12_Chapter05#ch5" title="Link target outside of Sample"><span class="bold">The Race for 200</span></span></h2>
<h2 class="toca"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Chapter Six</span></h2>
<h2 class="toca1"><span href="#/xhtml/13_Chapter06#ch6" title="Link target outside of Sample"><span class="bold">The Fight Continues</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Notes" title="Link target outside of Sample"><span class="bold">Notes</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e5c2f75a